import SwapVertIcon from "@mui/icons-material/SwapVert";
import {
  ArrayInput,
  Button,
  NumberInput,
  SimpleFormIterator,
  TextInput,
  maxValue,
  minValue,
  required,
  useNotify,
  useRecordContext,
  useRefresh,
} from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import { doctoralRequests } from "api/doctoralApi";
import { doctoralSeatLabel } from "../../seatLabel";

const ReorderSeatsDialog = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();

  const seats = record?.seats ?? [];
  if (seats.length < 2) return null;

  const defaultValues = {
    seats: [...seats]
      .sort((a, b) => a.priority - b.priority)
      .map(s => ({ doctoralSeatId: s.doctoralSeatId, label: doctoralSeatLabel(s), priority: s.priority })),
  };

  const handleConfirm = async data => {
    const payload = {
      seats: (data.seats ?? []).map(s => ({
        doctoralSeatId: s.doctoralSeatId,
        priority: Number(s.priority),
      })),
    };
    await dataProvider.customRequest(doctoralRequests.reorderCandidacySeats(record.id), payload, "PUT");
    notify("Желанията са разместени", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent="Разместване на желания"
      saveTitle="Запази"
      defaultValues={defaultValues}
      onConfirm={handleConfirm}
      triggerButton={
        <Button
          label="Разместване на желания"
          variant="contained"
          startIcon={<SwapVertIcon />}
        />
      }
    >
      <ArrayInput
        source="seats"
        label=""
      >
        <SimpleFormIterator
          disableAdd
          disableRemove
          disableReordering
          inline
        >
          <TextInput
            source="label"
            label="Докторантска програма"
            disabled
            fullWidth
          />
          <NumberInput
            source="priority"
            label="Желание"
            validate={[required(), minValue(1), maxValue(seats.length)]}
          />
        </SimpleFormIterator>
      </ArrayInput>
    </FormModal>
  );
};

export default ReorderSeatsDialog;
